export const PERFORMER_PROFILE_PATH = "/profile";

export const SOCIAL_MEDIA_POST_MESSAGE_AUTH_COMPLETE =
  "SOCIAL_MEDIA_POST_MESSAGE_AUTH_COMPLETE";

export const MY_HOME_PATH = "/myhome";

export const MY_HOME_ERROR_CODES_REDIRECTION = [400, 403, 404];

export const BASE_PATH = "/profile";

export const EDIT_PHOTO_PATH = "photos";

export const EDIT_PHOTO_FULL_PATH = `${BASE_PATH}/${EDIT_PHOTO_PATH}`;

export const MEDIA_PATH = "media";

export const EDIT_VIDEO_PATH = "video";

export const EDIT_AUDIO_PATH = "audio";

export const EDIT_VIDEO_FULL_PATH = `${BASE_PATH}/${MEDIA_PATH}/${EDIT_VIDEO_PATH}`;

export const EDIT_AUDIO_FULL_PATH = `${BASE_PATH}/${MEDIA_PATH}/${EDIT_AUDIO_PATH}`;
